import { render, staticRenderFns } from "./sale-invoice.vue?vue&type=template&id=2fc7384e&scoped=true&"
import script from "./sale-invoice.vue?vue&type=script&lang=js&"
export * from "./sale-invoice.vue?vue&type=script&lang=js&"
import style0 from "./sale-invoice.vue?vue&type=style&index=0&id=2fc7384e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7384e",
  null
  
)

export default component.exports